/* mp-gallery.js — the arrows, the counter and the keyboard on the product
   gallery.

   mp-shop.js already swaps the picture when a thumbnail is clicked, so none of
   that is repeated here. This file clicks the thumbnails on the buyer's behalf
   — from the arrows, the arrow keys, or a swipe — and keeps the counter and
   the scroll position of the strip in step. */
(function () {
  'use strict';

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function init(gal) {
    if (gal.dataset.mpg) { return; }
    gal.dataset.mpg = '1';

    var thumbs = $$('[data-thumb]', gal);
    if (thumbs.length < 2) { return; }

    var strip = $('[data-gal-strip]', gal);
    var main  = $('.main', gal);
    var iEl   = $('[data-gal-i]', gal);
    var nEl   = $('[data-gal-n]', gal);

    if (nEl) { nEl.textContent = pad(thumbs.length); }

    function at() {
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i].getAttribute('aria-pressed') === 'true') { return i; }
      }
      return 0;
    }

    var pic = $('[data-main-media]', gal);

    function sync() {
      var i = at();
      if (iEl) { iEl.textContent = pad(i + 1); }
      var t = thumbs[i];
      /* The box is reserved from the incoming file's own measurements, so the
         frame is never briefly the shape of the picture being replaced. */
      if (t && pic && t.dataset.w && t.dataset.h) {
        pic.setAttribute('width', t.dataset.w);
        pic.setAttribute('height', t.dataset.h);
      }
      if (t && strip) {
        var l = t.offsetLeft;
        var r = l + t.offsetWidth;
        var vl = strip.scrollLeft;
        var vr = vl + strip.clientWidth;
        if (l < vl + 14) { strip.scrollLeft = Math.max(0, l - 14); }
        else if (r > vr - 14) { strip.scrollLeft = r - strip.clientWidth + 14; }
      }
    }

    function go(step) {
      var i = (at() + step + thumbs.length) % thumbs.length;
      thumbs[i].click();
      thumbs[i].focus({ preventScroll: true });
    }

    var prev = $('[data-gal-prev]', gal);
    var next = $('[data-gal-next]', gal);
    if (prev) { prev.addEventListener('click', function () { go(-1); }); }
    if (next) { next.addEventListener('click', function () { go(1); }); }

    /* mp-shop.js binds its swap on each button, so this listener on the
       container runs after it and sees the new state. */
    gal.addEventListener('click', sync);

    gal.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
    });

    /* A swipe across the picture, on a phone. */
    if (main) {
      var x0 = null, y0 = null;
      main.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { x0 = null; return; }
        x0 = e.touches[0].clientX;
        y0 = e.touches[0].clientY;
      }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null || !e.changedTouches.length) { return; }
        var dx = e.changedTouches[0].clientX - x0;
        var dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 42 && Math.abs(dx) > Math.abs(dy) * 1.6) {
          go(dx < 0 ? 1 : -1);
        }
      }, { passive: true });
    }

    sync();
  }

  function boot() { $$('.mps-pdp .mps-gal').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
}());
